var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isDefault
    ? _c("app-input-with-textarea-modal", {
        attrs: { value: _vm.value, fancy: "", label: _vm.label },
        on: {
          input: function ($event) {
            return _vm.onValue($event)
          },
        },
      })
    : _vm.isAutocomplete
    ? _c("w-input-autocomplete", {
        attrs: {
          value: _vm.value,
          fancy: "",
          label: _vm.label,
          open: "",
          items: _vm.filteredAutocompleteItems,
        },
        on: {
          input: function ($event) {
            return _vm.onValue($event)
          },
          "item-click": function ($event) {
            return _vm.onValue($event)
          },
        },
      })
    : _vm.isSelect
    ? _c("w-select", {
        attrs: {
          fancy: "",
          label: _vm.label,
          value: _vm.value,
          items: _vm.selectItems,
        },
        on: {
          input: function ($event) {
            return _vm.onValue($event)
          },
        },
      })
    : _vm.isMultiSelect
    ? _c("w-multi-select", {
        attrs: {
          value: _vm.multiSelectValue,
          items: _vm.selectItems,
          label: _vm.label,
          fancy: "",
        },
        on: {
          input: function ($event) {
            return _vm.setMultiSelectValue($event)
          },
        },
      })
    : _vm.isContactAutoComplete
    ? _c(
        "div",
        [
          _vm.value
            ? _c("w-input", {
                attrs: {
                  label: _vm.label,
                  value: _vm.value,
                  icon: "times",
                  fancy: "",
                },
                on: { "icon-click": _vm.clearValue },
              })
            : _vm._e(),
          !_vm.value
            ? _c("app-contact-search", {
                attrs: {
                  "group-id": _vm.contactGroupIds,
                  label: _vm.label,
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setContactValue($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }